import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import { Layout } from './components/Layout';
import { OtpFaq } from './components/OtpFaq';

// general links
import Home from './components/Home';
import { WelcomePage } from './components/WelcomePage';
import AccountCreate from './components/AccountCreate';
import Authenticate from './components/Authenticate';
import EnterEmail from './components/EnterEmail';
import { NotAuthorized } from './components/NotAuthorized';
import Success from './components/Success';
import { Timeout } from './components/Timeout';
import Verify from './components/Verify';
import VerifyPhone from './components/VerifyPhone';
import Logout from './components/Logout';

// admin links
//import ProtectedRoute from "./components/common/protectedRoute";
import { ClientSearch } from "./components/Admin/ClientSearch";
import ClientProfile from "./components/Admin/ClientProfile";
import { UserSearch } from "./components/Admin/UserSearch";
import UserProfile from "./components/Admin/UserProfile";
import ViewLogs from "./components/Admin/ViewLogs";
import { Settings } from "./components/Admin/Settings";

import { NewAccountLocked } from './components/NewAccountLocked';
import ErrorPage from './components/ErrorPage';
import TokenExpired from './components/TokenExpired';

import "react-toastify/dist/ReactToastify.css";
import './custom.css'
import { datadogRum } from '@datadog/browser-rum';
datadogRum.startSessionReplayRecording();

export default class App extends Component {
    state = {};

  async componentDidMount() {
        document.documentElement.dir = 'ltr';
    document.documentElement.lang = 'en';

        var domain = window.location.host.split(".")[0];
        var env = 'local';
        switch (domain) {
        case 'otp-dev':
            env = 'dev';
            break;
        case 'otp-stg':
            env = 'stage';
            break;
        case 'otp-qa':
            env = 'qa';
            break;
        case 'otp':
            env = 'production';
            break;
        default:
            env = 'local';
            break;
        }

        //datadogRum.init({
        //        applicationId: '82c7e76d-b044-4017-828b-d9ba4ffc9e3c',
        //        clientToken: 'puba111bd892ea04a21910d3b51a8df3f6d',
        //        site: 'ddog-gov.com',
        //        service: 'OTP.WebUI',
        //        project: "OTP",
        //        env: env,
        //        sampleRate: 100,
        //        premiumSampleRate: 100,
        //        trackInteractions: true,
        //        defaultPrivacyLevel: 'allow',

        //        beforeSend: (event, context) => {
        //            if (event.type === 'resource' && event.resource.type === 'xhr') {
        //                event.context = {
        //                    ...event.context,
        //                    responseHeaders: context.response?.headers ?? "",
        //                    xhrresponse: context.xhr.response
        //                };
        //            }
        //        }
        //    }
        //);

        //datadogRum.addRumGlobalContext(
        //    "domain",
        //    domain
        //);
    }

    routes = function ()  {
        return (
            <React.Fragment>
                <ToastContainer
                    position="top-center"
                    autoClose={5000} //5000ms = 5s
                    //autoClose={false} // debugging
                    theme="colored"
                    rtl={false}
                />
                <Layout>
                    <Routes>
                        <Route path='/' element={<WelcomePage />} />
                        <Route path='/login' element={<Home />} />
                        <Route path='/home' element={<Home />} />
                        <Route path='/AccountCreate' element={<AccountCreate />} />
                        <Route path='/Authenticate/:email' element={<Authenticate />} />
                        <Route path='/EnterEmail' element={<EnterEmail />} />
                        <Route path='/NotAuthorized' element={<NotAuthorized />} />
                        <Route path='/Success' element={<Success />} />
                        <Route path='/Timeout' element={<Timeout />} />
                        <Route path='/Verify' element={<Verify />} />
                        <Route path='/VerifyPhone' element={<VerifyPhone />} />

                        <Route path='/ClientSearch' element={<ClientSearch />} />
                        <Route path='/ClientProfile' element={<ClientProfile />} />
                        <Route path='/UserSearch' element={<UserSearch />} />
                        <Route path='/UserProfile' element={<UserProfile />} />
                        <Route path='/ViewLogs' element={<ViewLogs />} />
                        <Route path='/Settings' element={<Settings />} />
                        <Route path='/NewAccountLocked' element={<NewAccountLocked />} />
                        <Route path='/error/' element={<ErrorPage />} />
                        <Route path='/tokenExpired' element={<TokenExpired />} />
                        <Route path='/logout' element={<Logout />} />
                        <Route path='/faq' element={<OtpFaq />} />
                    </Routes>
                </Layout>
            </React.Fragment>
        );
    }

    render() {        
        return (this.routes());
    }
}

